import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material";

@Component({
    selector: 'app-cart-notification',
    templateUrl: './cart-notification.component.html',
    styleUrls: ['./cart-notification.component.scss']
})
export class CartNotificationComponent implements OnInit {

    constructor(public dialog: MatDialogRef<CartNotificationComponent>) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/cart-notification/cart-notification.component.ts